import { useState, useEffect, useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';

export interface ViewSopModalProps {
  open: boolean;
  title?: string;
  nocValue?: string;
  sopContent?: string;
  theme?: string;
  onClose: () => void;
}

export function ViewSopModal({
  open,
  title = 'Standard Operating Procedure',
  nocValue = '',
  sopContent = '',
  theme,
  onClose,
}: ViewSopModalProps) {
  const [isLoading, setIsLoading] = useState(true);

  // When modal opens, show loading briefly
  useEffect(() => {
    if (open) {
      setIsLoading(true);
      requestAnimationFrame(() => {
        setIsLoading(false);
      });
    }
  }, [open]);

  // When content changes, update loading state
  useEffect(() => {
    requestAnimationFrame(() => {
      setIsLoading(false);
    });
  }, [sopContent]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const subheader = (
    <div className="kstc-sop-header">
      <span className="kstc-sop-noc-label">{nocValue}</span>
    </div>
  );

  return (
    <BaseFormModal
      open={open}
      title={title}
      theme={theme}
      dialogClass="kstc-dialog--sop"
      bodyClass="kstc-sop-body"
      showCancel={false}
      saveText="Close"
      subheader={nocValue ? subheader : undefined}
      onSave={handleClose}
      onCancel={handleClose}
    >
      {isLoading ? (
        <div className="kstc-sop-loading"><i className="fa fa-spinner fa-spin"></i> Loading...</div>
      ) : (
        <div
          className="kstc-sop-content"
          dangerouslySetInnerHTML={{ __html: sopContent }}
        />
      )}
    </BaseFormModal>
  );
}

(window as any).ViewSopModalReact = ViewSopModal;
